"use client"
import React,{useEffect,useRef,useState} from 'react'
import Footer from '../components/Footer';
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import ContactBanner from '../components/ContactBanner';
import { ProductProvider } from '../components/Productcontext';
import banner1 from '../images/contact/contact_banner.jpg';
import banner1_2x from '../images/contact/contact_banner@2x.jpg';
// import banner3 from '../images/contact/contact_banner_360.jpg';
import banner3 from '../images/contact/contact_banner_360@2x.jpg';
import banner_tab from '../images/contact/contact_banner_tab@2x.jpg';
import Contactcontet from '../components/Contactcontet';
import Contactform from '../components/Contactform';

const ContactPage = () => {
  const [isSticky, setSticky] = useState(true);
  const footerBackgroundColor = "gray";
  const displline= true;
  return (
    <div>
      
        {/* <PreHeader/>
        <Header isSticky={isSticky}/>
<Menu isHeaderVisible={isSticky}/> */}
    
<ContactBanner page="contact" banalt="Ashlok Safe Earthing Electrode Limited for earthing and lightning protection solutions" bannertext="" ban1x={banner1} ban2x={banner1_2x} ban360={banner3} bantab={banner_tab}/>

   <Contactcontet/>
   <Contactform/>
    <ProductProvider>
    <Footer backgroundColor={footerBackgroundColor} linedisp={displline}/>
    </ProductProvider>
    </div>
  )
}

export default ContactPage
